import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Typography, styled } from '@mui/material';

export const StyledCard = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isLogo',
})<{ isLogo?: boolean }>(({ isLogo }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: isLogo ? 'center' : 'flex-start',
	backgroundColor: '#fff',
	borderRadius: '10px',
	padding: '8px',
	width: '100%',
	height: '100%',
}));

export const StyledListItem = styled(Typography)(({ as }) => ({
	fontFamily: 'MuseoSansCyrl',
	...(as === 'li'
		? {
				textIndent: '-20px',
				paddingLeft: '20px',
			}
		: { textAlign: 'center', margin: 0, fontSize: '14px' }),
}));

export const CopyIcon = styled(ContentCopyIcon)({
	width: '20px',
	height: '20px',
	color: '#2090FF',
	cursor: 'pointer',
	transition: 'transform 0.3s ease',

	'&:hover': {
		transform: 'scale(1.2)',
	},

	'&:active': {
		transform: 'scale(0.9)',
	},
});

export const Logo = styled('img')({
	maxHeight: '32px',
	objectFit: 'contain',
});
